"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9562],{

/***/ 9562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FlightDistanceDT; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./utils/CommonUtils.js + 15 modules
var CommonUtils = __webpack_require__(6677);
;// CONCATENATED MODULE: ./components/FlightDistanceDT/Error.js

function ErrorFlightDistanceDT() {
    var errorMessage = '<div id="fullpage-error" class="fullpage-error-wrapper">\n    <div class="fullpage-error-container">\n        <span class="fullpage-error-icon" style="background-image: url(https://jsak.mmtcdn.com/seo/assets/img/ic_nocompatible_full.png);"></span>\n        <p class="error-title"> Sorry No flights found</p>\n        <div class="error-cta-wrapper">\n            </div>\n    </div>\n</div>';
    return (0,CommonUtils/* transformToHtml */.cR)(errorMessage);
}

;// CONCATENATED MODULE: ./components/FlightDistanceDT/Token.js
/* eslint-disable react/no-danger */ 
function Token(props) {
    var ref;
    var ref1 = (props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.data) || {}, _tokenJson = ref1.tokenJson, tokenJson = _tokenJson === void 0 ? {} : _tokenJson, intid = ref1.intid, devId = ref1.devId, mcid = ref1.mcid, isDeviceMobile = ref1.isDeviceMobile;
    var tokenString = "\n  var tokenJson = ".concat(JSON.stringify(tokenJson), ';\n  var intid = "').concat(intid || "", '";\n  var mmt = {};\n  mmt.hlp = {};\n  var devId = "').concat(devId, '";\n  var mcid = "').concat(mcid, '";\n  var device = "').concat(!isDeviceMobile ? "desktop" : "mobile", "\";\n  if(tokenJson.src_city_code){\n    var isDom = (tokenJson.src_country_code == 'IN') ? 'Y' : 'N';\n    var prefilledSrcCity = '{\"country\":\"'+ tokenJson.src_country_name + '\",\"iata\":\"'\n        + tokenJson.src_city_code + '\",\"iata_label\":\"'\n        + tokenJson.src_city_name + ', '+ tokenJson.src_country_name + ' ('\n        + tokenJson.src_city_code + ')\",\"isDom\":\"'+isDom+'\",\"fph_cd_s\":\"'\n        + tokenJson.src_city_code + '\",\"city\":\"'\n        + tokenJson.src_city_name + '\",\"fph_cty_s\":\"'+ tokenJson.src_country_code + '\"}';\n    }\n  if(tokenJson.dest_city_code){\n    var isDomDest = (tokenJson.dest_country_code == 'IN') ? 'Y' : 'N';\n    var prefilledDestCity = '{\"country\":\"'+ tokenJson.dest_country_name + '\",\"iata\":\"'\n        + tokenJson.dest_city_code + '\",\"iata_label\":\"'\n        + tokenJson.dest_city_name + ', '+ tokenJson.dest_country_name + ' ('\n        + tokenJson.dest_city_code + ')\",\"isDom\":\"'+isDomDest+'\",\"fph_cd_s\":\"'\n        + tokenJson.dest_city_code + '\",\"city\":\"'\n        + tokenJson.dest_city_name + '\",\"fph_cty_s\":\"'+ tokenJson.dest_country_code + '\"}';\n  }\n  var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = new Date(), serverTime = new Date(), noOfDaysToAddInDept = ").concat((tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.noOfDaysToAddInDept) || "", ", noOfDaysToAddInReturn = ").concat((tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.noOfDaysToAddInReturn) || "", ";\n  ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            dangerouslySetInnerHTML: {
                __html: tokenString
            }
        })
    });
}

;// CONCATENATED MODULE: ./components/FlightDistanceDT/index.js
/* eslint-disable @next/next/no-sync-scripts */ /* eslint-disable react/no-danger */ /* eslint-disable react-hooks/exhaustive-deps */ 



function FlightDistanceDT(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, appConfig = ref.appConfig, mainDiv = ref.main_div, seoContentDesc = ref.seo_content_desc, activeDate = ref.activeDate, srcCoordinates = ref.srcCoordinates, destCoordinates = ref.destCoordinates, blocksData = ref.blocksData, lang = ref.lang, ccde = ref.ccde, _isGoibibo = ref.isGoibibo, isGoibibo = _isGoibibo === void 0 ? false : _isGoibibo;
    var cssPath;
    var jsPath;
    // let imagePath;
    // let minExt;
    var lazyLoadingPath;
    var topOverlayPath;
    var seoWidgetPath;
    if (appConfig && appConfig.liveMode) {
        cssPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css";
        jsPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js";
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
    } else {
        cssPath = "http://localhost:3000/_next/static/css";
        jsPath = "http://localhost:3000/_next/static/js";
    // imagePath = '/images';
    // minExt = '';
    }
    lazyLoadingPath = "".concat(jsPath, "/lazyLoading.min.js");
    topOverlayPath = isGoibibo ? "".concat(jsPath, "/topOverlayGI.min.js") : "".concat(jsPath, "/top_overlay.min.js");
    seoWidgetPath = lang === "hin" ? "".concat(jsPath, "/hiSeoWidget2.min.js") : "".concat(jsPath, "/seoWidget2.min.js");
    var intentOfferOverlayCSSPath = "".concat(cssPath, "/intentOfferOverlay.min.css");
    var intentOfferOverlayJSPath = "".concat(jsPath, "/intentOffer.min.js");
    var googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
    var googleTagSrc = "https://www.googletagmanager.com/ns.html?id=".concat(googleTagId);
    var googletTagString = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer','".concat(googleTagId, "');\n  ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ccde || ccde === "in" || ccde === "IN" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    title: "distance",
                    src: googleTagSrc,
                    height: "0",
                    width: "0",
                    style: {
                        display: "none",
                        visibility: "hidden"
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n      var srcCoordinates = ".concat(JSON.stringify(srcCoordinates), ";\n      var destCoordinates = ").concat(JSON.stringify(destCoordinates), ";\n      ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "newSection",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fare-section marginTop126 hidden-xs",
                        id: "seoContentDesc",
                        children: (0,CommonUtils/* transformToHtml */.cR)(seoContentDesc)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "fare-header",
                        class: "weekly-fare-section container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "mobile-header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    class: "makeFlex hrtlCenter",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.makemytrip.com/flights/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                class: "back-button header-back-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "trip-details",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                class: "trip-summary font12",
                                                children: lang === "hin" ? "".concat(activeDate && activeDate !== "" ? "|" : "", " 1 वयस्क | इकोनॉमी") : "".concat(activeDate && activeDate !== "" ? "|" : "", " 1 Adult | Economy")
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "makeFlex FareStrip",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    class: "weekly-fare-carousel",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        class: "weekly-fare-carousel-container weekly-scroll",
                                        id: "fareStripLoader",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "placeholder-content",
                                            id: "placeholder"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fli-intl-container clearfix",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fli-intl-lhs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "seoOnlyBlock airline-left-container nopadding-mob paddR0 ",
                            children: [
                                mainDiv && mainDiv !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: mainDiv
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFlightDistanceDT, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.contentTop
                                    }
                                }),
                                mainDiv && mainDiv !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.contentMiddle
                                    }
                                }) : "",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.contentBottom
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.bottomBlock
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ",
                            children: [
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData.rightBlock),
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData.leftBlock)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Token, {
                data: props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(lazyLoadingPath)
            }),
            lang === "hin" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: "\n            .filter-options .ui-datepicker {\n                width: 675px!important;\n            }\n            .ui-datepicker-multi-2 .ui-datepicker-group {\n                margin: 14px 22px 0;\n            }\n            .filter-options .ui-datepicker .ui-datepicker-header .ui-datepicker-title {\n                font-size: 18px !important;\n                font-weight: bolder !important;\n                color: #000 !important;\n                text-align: center !important;\n            }\n            .filter-options .ui-datepicker .ui-datepicker-header .ui-datepicker-title .ui-datepicker-year {\n                font-size: 18px !important;\n                font-weight: bolder !important;\n                color: #000 !important;\n                text-align: center !important;\n            }\n            .modify-search-label {\n                line-height: 18px !important;\n            }\n            .filter-options .ui-datepicker-calendar thead th {\n                font-size: 1em;\n            }\n\n            .modify-search-input-field {\n                line-height: 21px !important;\n            }"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                src: "".concat(seoWidgetPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(topOverlayPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "seo-bottom",
                class: "seo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    name: "domain_id",
                    id: "domain_id",
                    type: "hidden",
                    value: "www_intl_flight_makemytrip_com"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "".concat(intentOfferOverlayCSSPath),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(intentOfferOverlayJSPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: blocksData.top_overlay
                }
            }),
            ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: googletTagString
                }
            }) : null
        ]
    });
}


/***/ })

}]);